import { stringify } from 'query-string'

import { TRACKING_DATA_KEYS } from 'shared/consts'

export const enhanceWithTrackingData = (
  url: string,
  trackingData: Record<
    typeof TRACKING_DATA_KEYS[number],
    string | number | undefined
  >
): string => {
  if (!Object.keys(trackingData).length) {
    return url
  }

  const hasSearch = url.includes('?')
  const trackingParams = stringify(trackingData)

  return `${url}${hasSearch ? '&' : '?'}${trackingParams}`
}
